import { ROUTES } from '@/routes';
import { current } from '@reduxjs/toolkit';

export const REDIRECT_URIS = {
  local: 'http://localhost:5173/signin/kakao/callback',
  dev: 'https://app-dev.sellerbox.io/signin/kakao/callback',
  prod: 'https://app.sellerbox.io/signin/kakao/callback',
};

export const getRedirectUri = () => {
  const { hostname } = window.location;
  if (hostname.includes('localhost')) return REDIRECT_URIS.local;
  if (hostname.includes('app-dev.sellerbox.io')) return REDIRECT_URIS.dev;
  if (hostname.includes('app.sellerbox.io') && !hostname.includes('dev')) return REDIRECT_URIS.prod;
  return REDIRECT_URIS.prod;
};

export const CLIENT_ID = import.meta.env.VITE_APP_REST_API_KEY;

export const KAKAO_AUTH_URL = `https://kauth.kakao.com/oauth/authorize?client_id=${CLIENT_ID}&redirect_uri=${getRedirectUri()}&response_type=code&prompt=login`;

export const VERSION_CONFIG = {
  currentVersion: '3.0.0',
  osType: 'web',
};

// 관리자 번호 목록
export const ADMIN_PHONES = [
  '010-9348-3900', // admin
  // '010-4463-0526', // bell
  // '010-2989-3589', // hazel
  // '010-3157-2704', // jack
  // '010-4692-2031', // jane
  // '010-4695-5394', // jerry
  // '010-7503-1603', // tony
  // '010-3547-2548', // tommy
];
// 요청용 대표 관리자 번호
export const ADMIN_SERVER_PHONE = '01093483900';
